import { useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { customToastify } from "../../pages/utils/utilsFunctions";
import { Button, Divider } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
import Typography from "@mui/material/Typography";
import DraggableComponent from "../DraggableComponent";
import CompareSubsBox from "./CompareSubsBox";
import CompareSubsPlayingSerachBox from "./CompareSubsPlayingSerachBox";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";

export default function CompareSubsPlaying(props) {
  const {
    mainCompareSubsOpen,
    handleMainCompareSubsOpen,
    handleCompareSubtitlesData,
    videoRef,
  } = props;
  const [openSearchBox, setOpenSearchBox] = useState(false);
  const [compareSubsBox, setCompareSubsBoxOpen] = useState(false);
  const [selectedSub, setSelectedSub] = useState({
    subOne: false,
    subTwo: false,
  });
  const [mainCompareSubsDialog, setMainCompareSubsDialog] = useState(true);
  const [subtitlesListId, setSubtitlesListId] = useState([]);
  const [compareSubtitlesListId, setCompareSubtitlesListId] = useState([]);
  const [subtitlesListUploads, setSubtitlesListUploads] = useState([]);
  const [compareSubtitlesListUploads, setCompareSubtitlesListUploads] =
    useState([]);
  const [allSubtitlesList, setAllSubtitlesList] = useState([]); //[{type:"id",content:"id",subOne:true,subTwo:true,show:true},{type:"file",content:"file",subOne:true,subTwo:true,show:true}]
  const [subtitlesTimeShift, setSubtitlesTimeShift] = useState({});
  const [tabValue, setTabValue] = useState("1");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleOpenSearchBox = (state) => {
    setOpenSearchBox(state);
  };
  const handleCompareSubsBox = (state) => {
    setCompareSubsBoxOpen(state);
  };
  const handleMeainCompareSubsDialog = (state) => {
    setMainCompareSubsDialog(state);
  };

  const handleSubtitlesTimeShift = (index, data, initial) => {
    let cp;
    if (initial) {
      cp = { ...subtitlesTimeShift, ...data };
    } else {
      cp = { ...subtitlesTimeShift };
      cp[`sub${index}`] = (cp[`sub${index}`] * 10 + data * 10) / 10;
      setTimeToTracks(index, data);
    }
    setSubtitlesTimeShift(cp);
  };

  const setTimeToTracks = (subNumber, time) => {
    const video = document.querySelector("video");
    let floatTime = parseFloat(time);
    if (video) {
      if (
        allSubtitlesList.length !== video.textTracks.length &&
        video.textTracks[0]["id"] == "subtitlesOneTrack"
      )
        subNumber =
          subNumber + video.textTracks.length - allSubtitlesList.length;
      let textTracks = video.textTracks[subNumber];
      if (textTracks)
        Array.from(textTracks.cues).forEach((cue) => {
          cue.startTime += floatTime;
          cue.endTime += floatTime;
        });
    }
  };

  const handleSubtitlesListId = (action, id, index) => {
    let cp = [...subtitlesListId];
    if (action == "addId") {
      if (cp.indexOf(id) == -1) cp.push(id);
    } else if (action == "deleteId") {
      cp.splice(index, 1);
    } else if (action == "add20") {
      id.forEach((oneId) => {
        if (cp.indexOf(oneId) == -1) cp.push(oneId);
      });
    }
    setSubtitlesListId(cp);
  };

  const handleSubtitlesListUploads = (action, file, index) => {
    let cp = [...subtitlesListUploads];
    if (action == "addFile") {
      let newFile = true;
      subtitlesListUploads.forEach((sub) => {
        if (sub.name == file.name && sub.size == file.size) newFile = false;
      });
      if (newFile) cp.push(file);
    } else if (action == "deleteFile") {
      cp.splice(index, 1);
    }
    setSubtitlesListUploads(cp);
  };

  const handlesAllSubtitlesList = (action, index, subNumber, newAll) => {
    if (subtitlesListId.length + subtitlesListUploads.length < 1) {
      customToastify("error", "برای مقایسه نیاز به حداقل یک زیرنویس است");
    } else if (action == "continueCompareSubs") {
      handleCompareSubsBox(true);
      const cpAll = [...allSubtitlesList];
      let newIds = subtitlesListId.filter(
        (el) => compareSubtitlesListId.indexOf(el) == -1
      );
      let newFiles = subtitlesListUploads.filter(
        (el) => compareSubtitlesListUploads.indexOf(el) == -1
      );
      newIds.forEach((el) => {
        let newSub = {
          type: "id",
          content: el,
          subOne: false,
          subTwo: false,
          show: true,
        };
        cpAll.push(newSub);
      });
      newFiles.forEach((el) => {
        let newSub = {
          type: "file",
          content: el,
          subOne: false,
          subTwo: false,
          show: true,
        };
        cpAll.push(newSub);
      });
      const cpIds = [...subtitlesListId, ...newIds];
      const cpfiles = [...subtitlesListUploads, ...newFiles];
      setCompareSubtitlesListId(cpIds);
      setCompareSubtitlesListUploads(cpfiles);
      setAllSubtitlesList(cpAll);
      handleMeainCompareSubsDialog(false);
    } else if (action == "compareSubs") {
      handleCompareSubsBox(true);
      let all = [];
      subtitlesListId.forEach((el) => {
        let newSub = {
          type: "id",
          content: el,
          subOne: false,
          subTwo: false,
          show: true,
        };
        all.push(newSub);
      });
      subtitlesListUploads.forEach((el) => {
        let newSub = {
          type: "file",
          content: el,
          subOne: false,
          subTwo: false,
          show: true,
        };
        all.push(newSub);
      });
      setCompareSubtitlesListId(subtitlesListId);
      setCompareSubtitlesListUploads(subtitlesListUploads);
      setAllSubtitlesList(all);
      handleMeainCompareSubsDialog(false);
    } else if (action == "hiddenSub") {
      if (index >= 0) {
        let newvalue = allSubtitlesList.map((el, idx) => {
          if (idx == index) el["show"] = !el["show"];
          return el;
        });
        setAllSubtitlesList(newvalue);
      } else console.log("Error handlesAllSubtitlesList-hiddenSub");
    } else if (action == "selectSub") {
      if (index >= 0 && subNumber == "subOne") {
        let newvalue = allSubtitlesList.map((el, idx) => {
          if (idx == index) el["subOne"] = !el["subOne"];
          else el["subOne"] = false;
          return el;
        });
        setAllSubtitlesList(newvalue);
      } else if (index >= 0 && subNumber == "subTwo") {
        let newvalue = allSubtitlesList.map((el, idx) => {
          if (idx == index) el["subTwo"] = !el["subTwo"];
          else el["subTwo"] = false;
          return el;
        });
        setAllSubtitlesList(newvalue);
      } else console.log("Error handlesAllSubtitlesList-selectSub");
    } else if (action == "closeCompareSubsBox") {
      handleCompareSubsBox(false);
      handleMeainCompareSubsDialog(true);
      let cpSelectedSub = { subOne: false, subTwo: false };
      allSubtitlesList.map((el, idx) => {
        if (el["subTwo"]) {
          cpSelectedSub["subTwo"] = el;
          cpSelectedSub["subTwo"]["timeShift"] =
            subtitlesTimeShift[`sub${idx}`];
        }
        if (el["subOne"]) {
          cpSelectedSub["subOne"] = el;
          cpSelectedSub["subOne"]["timeShift"] =
            subtitlesTimeShift[`sub${idx}`];
        }
      });
      setSelectedSub(cpSelectedSub);
    } else if (action == "sortSubtitles") {
      setAllSubtitlesList(newAll);
    }
  };

  const removeTracksFromVideo = async () => {
    try {
      let video = document.querySelector("#MainVideo video");
      allSubtitlesList.forEach((sub, idx) => {
        let oldTrack = document.getElementById(
          `compareSubtitlesTrack${idx + 3}`
        );
        if (oldTrack) video.removeChild(oldTrack);
      });
      setAllSubtitlesList([]);
      setSelectedSub({ subOne: false, subTwo: false });
      setSubtitlesListId([]);
      setCompareSubtitlesListId([]);
      setSubtitlesListUploads([]);
      setCompareSubtitlesListUploads([]);
      setSubtitlesTimeShift([]);
    } catch (error) {
      console.log("Error in addTrackToVideo", error);
    }
  };

  return (
    <Box
      sx={{ width: "100%", display: mainCompareSubsOpen ? "block" : "none" }}
    >
      <DraggableComponent maxWidth={"100%"}>
        <CompareSubsPlayingSerachBox
          handleSubtitlesListId={handleSubtitlesListId}
          subtitlesListId={subtitlesListId}
          openSearchBox={openSearchBox}
          handleOpenSearchBox={handleOpenSearchBox}
          handleMeainCompareSubsDialog={handleMeainCompareSubsDialog}
        />
        <CompareSubsBox
          videoRef={videoRef}
          compareSubsBox={compareSubsBox}
          handlesAllSubtitlesList={handlesAllSubtitlesList}
          allSubtitlesList={allSubtitlesList}
          handleSubtitlesTimeShift={handleSubtitlesTimeShift}
          subtitlesTimeShift={subtitlesTimeShift}
        />
        <Paper
          sx={{
            display: mainCompareSubsDialog ? "block !important" : "none",
            width: "80%",
            m: "10%",
            position: "relative",
            textAlign: "center",
            borderRadius: "10px",
            p: 1,
          }}
        >
          {/* <Typography sx={{color: "red",textAlign: "center",display:errorSuffix?"block":"none"}}>{errorSuffix=="zip"?"*خطا: لطفا ابتدا فایل زیرنویس را از حالت فشرده(zip) خارج کنید*":"*خطا: لطفا فایل با پسوند srt انتخاب کنید*"}</Typography> */}
          <Divider sx={{ textAlign: "center" }}>
            مقایسه و انتخاب بهترین زیرنویس
          </Divider>
          <Typography sx={{ fontSize: "10px" }}>
            این ابزار زیرنویس های مختلف در کنار یکدیگر نمایش می دهد و می توانید
            هماهنگ ترین زیرنویس را انتخاب کنید
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography>
              <LooksOneIcon />
            </Typography>
            <Box
              sx={{
                border: "1px solid",
                paddingLeft: "5px",
                paddingRight: "5px",
                borderRadius: "5px",
              }}
            >
              <Button
                color="info"
                onClick={() => {
                  handleOpenSearchBox(true);
                  handleMeainCompareSubsDialog(false);
                  // if (userTypes.length > 0) {
                  //     handleSearchSubtitlesBoxOpen(true, true, { formProps: props, subNumber: "one" })
                  // } else {
                  //     handleOpenSignInBox()
                  //     setTimeout(() => {
                  //         customToastify("error", "لطفا ابتدا وارد شوید و سپس بر روی جستجوی زیرنویس کلیک کنید");
                  //     }, 500);
                  // }
                }}
                variant="contained"
                id="1"
                component="label"
                sx={{ minWidth: "225px", m: 0.5 }}
              >
                جستوجوی زیرنویس
                <SearchIcon sx={{ mx: 1 }} />
              </Button>
              <Button
                color="info"
                variant="contained"
                component="label"
                sx={{ minWidth: "225px", mx: 0.5 }}
              >
                انتخاب فایل SRT
                <input
                  hidden
                  id="subtitleOneFile"
                  name="subtitleOneFile"
                  type="file"
                  onChange={(event) => {
                    if (event.target.files[0]) {
                      if (
                        event.target.files[0].name
                          .slice(-4)
                          .toLocaleLowerCase() == ".zip" ||
                        event.target.files[0].name
                          .slice(-4)
                          .toLocaleLowerCase() == ".rar"
                      ) {
                        // setErrorSuffix("zip")
                      } else if (
                        event.target.files[0].name
                          .slice(-4)
                          .toLocaleLowerCase() !== ".srt"
                      ) {
                        // setErrorSuffix("nosrt")
                      } else {
                        // setErrorSuffix(false)
                        handleSubtitlesListUploads(
                          "addFile",
                          event.target.files[0]
                        );
                        // props.setFieldValue(
                        //     "subtitleOneFile",
                        //     event.target.files[0]
                        // );
                        // handleSubtitleFileName(
                        //     "one",
                        //     false,
                        //     event.target.files[0]
                        // );
                        // setSubOneId("")
                      }
                    }
                  }}
                />
                <ClosedCaptionIcon sx={{ mx: 1 }} />
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "2px",
            }}
          >
            <Typography>
              <LooksTwoIcon />
            </Typography>
            <Box
              sx={{
                border: "1px solid",
                paddingLeft: "5px",
                paddingRight: "5px",
                borderRadius: "5px",
              }}
            >
              {allSubtitlesList.length == 0 ? (
                <Button
                  onClick={() => {
                    handlesAllSubtitlesList("compareSubs", 0, 0);
                    handleTabChange(null, 2);
                  }}
                  variant="contained"
                  id="1"
                  component="label"
                  sx={{ minWidth: "225px", m: 0.5 }}
                  color="primary"
                >
                  شروع مقایسه
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    handlesAllSubtitlesList("continueCompareSubs", 0, 0);
                    handleTabChange(null, 2);
                  }}
                  variant="contained"
                  id="1"
                  component="label"
                  sx={{ minWidth: "225px", m: 0.5 }}
                  color="primary"
                >
                  ادامه مقایسه
                </Button>
              )}
              <Button
                onClick={() => {
                  removeTracksFromVideo();
                }}
                variant="contained"
                id="1"
                component="label"
                sx={{ minWidth: "225px", m: 0.5 }}
                color="error"
              >
                ریست مقایسه
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "2px",
            }}
          >
            <Typography>
              <Looks3Icon />
            </Typography>
            <Box
              sx={{
                border: "1px solid",
                paddingLeft: "5px",
                paddingRight: "5px",
                borderRadius: "5px",
              }}
            >
              <Button
                onClick={() => {
                  handleMainCompareSubsOpen(false);
                }}
                variant="contained"
                id="1"
                component="label"
                sx={{ minWidth: "225px", m: 0.5 }}
                color="warning"
              >
                بستن
              </Button>
              <Button
                disabled={!(selectedSub["subOne"] || selectedSub["subTwo"])}
                onClick={() => {
                  handleMainCompareSubsOpen(false);
                  handleCompareSubtitlesData({ newData: true, ...selectedSub });
                  removeTracksFromVideo();
                }}
                variant="contained"
                id="1"
                component="label"
                sx={{ minWidth: "225px", m: 0.5 }}
                color="success"
              >
                {`انتخاب زیرنویس ${selectedSub["subOne"] ? "اول و" : ""} ${
                  selectedSub["subTwo"] ? "دوم و" : ""
                } ادامه`}
              </Button>
            </Box>
          </Box>
          {subtitlesListId.length > 0 || subtitlesListUploads.length > 0 ? (
            <TabContext value={tabValue}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleTabChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="انتخاب شده" value="1" />
                  <Tab label="مقایسه شده" value="2" />
                </TabList>
              </Box>
              <Box sx={{ display: tabValue == 1 ? "block" : "none" }}>
                {subtitlesListId.length > 0 ? (
                  <>
                    {/* <Typography>
                                        لیست زیرنویس های انتخاب شده در جستوجو
                                    </Typography> */}
                    {subtitlesListId.map((sub, idx) => (
                      <Button
                        key={`subids-${idx + 2}`}
                        sx={{ mx: 0.1 }}
                        size="small"
                        //  endIcon={<DeleteIcon onClick={() => { handleSubtitlesListId("deleteId", sub, idx) }} color="warning" />}
                      >
                        {sub}
                      </Button>
                    ))}
                  </>
                ) : null}
                <br />

                {subtitlesListUploads.length > 0 ? (
                  <>
                    {/* <Typography>
                                        لیست زیرنویس های بارگزاری شده
                                    </Typography> */}
                    {subtitlesListUploads.map((file, idx) => (
                      <Button
                        key={`subids-${idx + 2}`}
                        sx={{ mx: 0.1 }}
                        size="small"
                        //  endIcon={<DeleteIcon onClick={() => { handleSubtitlesListUploads("deleteFile", file, idx) }} color="warning" />}
                      >
                        {file.name.slice(0, 40)}
                      </Button>
                    ))}
                  </>
                ) : null}
              </Box>
              <Box sx={{ display: tabValue == 2 ? "block" : "none" }}>
                {allSubtitlesList.map((el, idx) => (
                  <Button
                    key={`subidsSelect-${idx + 2}`}
                    size="small"
                    onClick={() => {
                      handlesAllSubtitlesList("hiddenSub", idx);
                    }}
                    sx={{ m: 0.1 }}
                    color={el["show"] ? "success" : "error"}
                    variant="contained"
                    endIcon={
                      el["show"] ? <VisibilityIcon /> : <VisibilityOffIcon />
                    }
                  >
                    {el.type == "id"
                      ? el["content"]
                      : el["content"]["name"].slice(
                          el["content"]["name"].length - 30,
                          el["content"]["name"].length
                        )}
                  </Button>
                ))}
              </Box>
              <hr />
            </TabContext>
          ) : null}
        </Paper>
      </DraggableComponent>
    </Box>
  );
}
